import React, { useState } from 'react';
import { Link } from 'react-scroll';
import { FaBars, FaTimes } from 'react-icons/fa';
import logo from '../assets/logo.png';

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const links = [
    { name: 'Home', to: 'hero' },
    { name: 'About', to: 'about' },
    { name: 'Products', to: 'products' },
    { name: 'Services', to: 'services' },
    { name: 'Tech', to: 'tech' },
    { name: 'Research', to: 'research' },
    { name: 'Contact', to: 'contact' },
  ];

  return (
    <nav className="fixed w-full z-50 bg-gray-800/60 backdrop-blur-md py-4 px-6 flex justify-between items-center">
      <div className="flex items-center text-white font-bold text-xl space-x-2">
        <div className="p-1 bg-white/20 rounded-full">
            <img src={logo} alt="Munorva logo" className="h-12 w-auto" />
          </div>
        <span>Munorva</span>
      </div>
      <ul className="hidden md:flex space-x-6 text-white">
        {links.map((l) => (
          <li key={l.to}>
            <Link to={l.to} smooth={true} duration={500} onClick={() => setOpen(false)}>
              {l.name}
            </Link>
          </li>
        ))}
      </ul>
      <div className="md:hidden text-white" onClick={() => setOpen(!open)}>
        {open ? <FaTimes /> : <FaBars />}
      </div>
      {open && (
        <ul className="absolute top-full left-0 w-full bg-gray-900 flex flex-col items-center py-4 space-y-4">
          {links.map((l) => (
            <li key={l.to}>
              <Link to={l.to} smooth={true} duration={500} onClick={() => setOpen(false)}>
                {l.name}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
